import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import LogosTab from "@/components/brandkit/LogosTab";
import ColorsTab from "@/components/brandkit/ColorsTab";
import FontsTab from "@/components/brandkit/FontsTab";
import AssetsTab from "@/components/brandkit/AssetsTab";
import RulesTab from "@/components/brandkit/RulesTab";
import ContentTab from "@/components/brandkit/ContentTab";
import { BRAND_KIT } from "@/constants/brandKitTestIds";

const TABS = [
  { id: "logos",   label: "Brand Logos",   testid: BRAND_KIT.tabLogos,   Component: LogosTab  },
  { id: "colors",  label: "Brand Colors",  testid: BRAND_KIT.tabColors,  Component: ColorsTab },
  { id: "fonts",   label: "Brand Fonts",   testid: BRAND_KIT.tabFonts,   Component: FontsTab  },
  { id: "assets",  label: "Brand Assets",  testid: BRAND_KIT.tabAssets,  Component: AssetsTab },
  { id: "rules",   label: "Brand Rules",   testid: BRAND_KIT.tabRules,   Component: RulesTab },
  { id: "content", label: "Brand Content", testid: BRAND_KIT.tabContent, Component: ContentTab },
];

export default function BrandKit() {
  const { brandId } = useParams();
  const { user } = useAuth();
  const [brand, setBrand] = useState(null);
  const [tab, setTab] = useState("logos");
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/brands/${brandId}`)
      .then(({ data }) => setBrand(data))
      .catch(() => setError("Brand not found"));
    // Persist tab across remounts via URL hash
    const fromHash = window.location.hash?.replace("#", "");
    if (fromHash && TABS.find((t) => t.id === fromHash)) setTab(fromHash);
  }, [brandId]);

  const onTab = (id) => {
    setTab(id);
    window.history.replaceState(null, "", `#${id}`);
  };

  if (error) return <p className="text-[#B5462F]">{error}</p>;
  if (!brand) return <p className="text-[#6B6358]">Loading…</p>;

  const ActiveTab = TABS.find((t) => t.id === tab)?.Component || LogosTab;
  const canManage = !!user?.is_platform_admin;

  return (
    <div data-testid={BRAND_KIT.pageRoot} className="max-w-6xl">
      <p className="text-xs uppercase tracking-[0.22em] text-[#B5462F] mb-3">
        {brand.name} &middot; Brand Kit
      </p>
      <h1 className="font-serif text-5xl tracking-tight">Brand Kit</h1>
      <p className="text-base text-[#3D3A35] mt-3 max-w-2xl">
        The single source of truth for this brand&rsquo;s logos, palette,
        typography and supporting graphic devices. Rules reference these assets;
        the AI Assembly Agent draws from them when generating wraps.
      </p>

      <div className="mt-10 flex gap-1 border-b border-[#1A1F2C]/10">
        {TABS.map((t) => (
          <button
            key={t.id}
            data-testid={t.testid}
            onClick={() => onTab(t.id)}
            className={`px-5 py-3 text-sm font-medium border-b-2 transition-colors ${
              tab === t.id
                ? "border-[#B5462F] text-[#1A1F2C]"
                : "border-transparent text-[#6B6358] hover:text-[#1A1F2C]"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-8">
        <ActiveTab brandId={brandId} canManage={canManage} />
      </div>
    </div>
  );
}
